export const summary =
	'Results-driven Mobile Engineer skilled to design, develop, and deploy mobile apps to both App store and Play store utilizing data-driven insights to guide development of programs and apps that fill a user need utilizing active listening skills.'
